module.exports = __webpack_public_path__ + "img/電気回路_2_3.b94af383.png";